import FooterIcons from "./components/FooterIcons";

const AuthFooter: React.FC = () => {

return (
    <footer className="text-center mt-0">
        <div className="container mx-auto">
            <div className="flex flex-wrap items-center md:justify-between justify-center">
                <div className="w-full px-2 mx-auto">
                    <div className="text-sm text-white font-semibold py-1">
                        © Educare Skills. &{' '}
                        <a
                            href="https://educareskill.com/"
                            className="text-white hover:text-gray-800"
                            target="_blank"
                            rel="noreferrer"
                        >
                            iBEST,
                        </a>{' '}
                        Thimphu,{' '}
                        <a
                            href="https://www.ibeststudios.com/"
                            className="text-white hover:text-blueGray-800"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Bhutan.
                        </a>
                    </div>
                    <FooterIcons/>
                </div>
            </div>
        </div>
    </footer>
    );
};

export default AuthFooter;
